<div [class]="getTabsClass()">
  <div class="td-wb-tabs__list">
    <ng-content select="td-wb-tab" />
  </div>
  <div class="td-wb-tabs__toolbar">
    <ng-content select="td-wb-tabs-toolbar"
                [attr.aria-label]="ariaLabelToolbar()" />
  </div>
</div>
